<template>
  <div class="title-block-center-container">
    <h5
      class="title-content"
      :class="device.isMobile ? 'title-content-mobile' : ''"
      :id="content.key"
      :style="{
        fontFamily: content.textStyle.fontFamily || '',
        fontSize: (content.textStyle.fontSize + 'rem') || '',
        lineHeight: (content.textStyle.lineHeight + 'rem') || '',
        textIndent: (typeof content.textStyle.textIndent === 'string') ? content.textStyle.textIndent :
          (typeof content.textStyle.textIndent === 'number') ? (content.textStyle.textIndent + 'rem') : '',
        fontWeight: content.textStyle.fontWeight || '',
        textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.textStyle.textAlign || '',
        color: content.textStyle.color || '',
        backgroundColor: content.textStyle.backgroundColor || '',
        backgroundImage: content.textStyle.backgroundImage ? `url(${content.textStyle.backgroundImage})` : '',
        width: (typeof content.textStyle.width === 'string') ? content.textStyle.width :
          (typeof content.textStyle.width === 'number') ? (content.textStyle.width + 'rem') : '',
        marginTop: (content.textStyle.marginTop + 'rem') || '',
        marginBottom: (content.textStyle.marginBottom + 'rem') || '',
        padding: (typeof content.textStyle.padding === 'number' && (content.textStyle.padding + 'rem')) || '',
        paddingTop: (typeof content.textStyle.paddingTop === 'number' && (content.textStyle.paddingTop + 'rem')) || '',
        paddingBottom: (typeof content.textStyle.paddingBottom === 'number' && (content.textStyle.paddingBottom + 'rem')) || '',
        paddingLeft: (typeof content.textStyle.paddingLeft === 'number' && (content.textStyle.paddingLeft + 'rem')) || '',
        paddingRight: (typeof content.textStyle.paddingRight === 'number' && (content.textStyle.paddingRight + 'rem')) || '',
        borderRadius: content.textStyle.borderRadius
          ? content.textStyle.borderRadius.borderTopLeftRadius +
            'rem' +
            ' ' +
            (content.textStyle.borderRadius.borderTopRightRadius + 'rem') +
            ' ' +
            (content.textStyle.borderRadius.borderBottomRightRadius + 'rem') +
            ' ' +
            (content.textStyle.borderRadius.borderBottomLeftRadius + 'rem')
          : '',
      }"
      v-html="content.text"
    ></h5>
  </div>
</template>
<script>
/*
标题 - 整个标题居中显示 文字居中
*/
export default {
  name: "title-block-center",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-block-center-container{
  display: flex;
  align-items: center;
  justify-content: center;

  .title-content{
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32rem;
    color: #fff;
    text-indent: 0;
  }

  .title-text{
    text-align: center;
    display: block;
  }
}
</style>